/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfGetTagForEditOutput } from "../models/AjaxResponseOfGetTagForEditOutput";
import type { AjaxResponseOfListOfTagDto } from "../models/AjaxResponseOfListOfTagDto";
import type { AjaxResponseOfPagedResultDtoOfGetTagForViewDto } from "../models/AjaxResponseOfPagedResultDtoOfGetTagForViewDto";
import type { CreateOrEditTagDto } from "../models/CreateOrEditTagDto";

import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";

export class TagsAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns any Success
   * @throws ApiError
   */
  public createOrEdit({
    requestBody,
  }: {
    requestBody?: CreateOrEditTagDto;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/tags",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public delete({ id }: { id?: number }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/tags",
      query: {
        id: id,
      },
    });
  }

  /**
   * @returns AjaxResponseOfPagedResultDtoOfGetTagForViewDto
   * @throws ApiError
   */
  public getAll({
    filter,
    descriptionFilter,
    colorFilter,
    sorting,
    skipCount,
    maxResultCount,
  }: {
    filter?: string;
    descriptionFilter?: string;
    colorFilter?: string;
    sorting?: string;
    skipCount?: number;
    maxResultCount?: number;
  }): CancelablePromise<AjaxResponseOfPagedResultDtoOfGetTagForViewDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/tags",
      query: {
        filter: filter,
        descriptionFilter: descriptionFilter,
        colorFilter: colorFilter,
        sorting: sorting,
        skipCount: skipCount,
        maxResultCount: maxResultCount,
      },
    });
  }

  /**
   * @returns AjaxResponseOfListOfTagDto
   * @throws ApiError
   */
  public getAllList(): CancelablePromise<AjaxResponseOfListOfTagDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/tags/get-all-list",
    });
  }

  /**
   * @returns AjaxResponseOfGetTagForEditOutput
   * @throws ApiError
   */
  public getTagForEdit({
    id,
  }: {
    id: number;
  }): CancelablePromise<AjaxResponseOfGetTagForEditOutput> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/tags/{id}",
      path: {
        id: id,
      },
    });
  }
}
